import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../TimeExtent.js";
import { unwrap as e, isSome as n, isNone as i } from "../core/maybe.js";
import { eachAlways as o } from "../core/promiseUtils.js";
import { offsetDate as r } from "../core/timeUtils.js";

function m(t) {
  return "feature" === (null == t ? void 0 : t.type);
}

function s(t) {
  return "map-image" === (null == t ? void 0 : t.type);
}

function f(t) {
  return void 0 !== t.timeInfo;
}

function u(_x, _x2) {
  return _u.apply(this, arguments);
}

function _u() {
  _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n, r) {
    var u, a, l, _iterator, _step, _t, c, p, T, d;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(0 === n.length)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", t.allTime);

          case 2:
            u = n.filter(f);
            _context2.next = 5;
            return Promise.all(u.map(function (t) {
              return t.load({
                signal: r
              });
            }));

          case 5:
            a = [], l = [];
            _iterator = _createForOfIteratorHelper(u);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _t = _step.value;
                (m(_t) || s(_t)) && _t.timeInfo.hasLiveData ? a.push(_t) : l.push(_t);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            c = function c(t) {
              return i(t) || t.isAllTime;
            }, p = l.map(function (t) {
              return t.timeInfo.fullTimeExtent;
            });

            if (!p.some(c)) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", t.allTime);

          case 11:
            T = a.map( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
                var _yield$t$fetchRecompu, n;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return t.fetchRecomputedExtents({
                          signal: r
                        });

                      case 2:
                        _yield$t$fetchRecompu = _context.sent;
                        n = _yield$t$fetchRecompu.timeExtent;
                        return _context.abrupt("return", n || e(t.timeInfo.fullTimeExtent));

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }());
            _context2.next = 14;
            return o(T);

          case 14:
            d = _context2.sent.map(function (t) {
              return t.value;
            });

            if (!d.some(c)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", t.allTime);

          case 17:
            return _context2.abrupt("return", d.concat(p).reduce(function (t, e) {
              return t.union(e);
            }));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _u.apply(this, arguments);
}

function a(e) {
  if (!e) return e;
  var i = e.start,
      o = e.end;
  return new t({
    start: n(i) ? r(i, -i.getTimezoneOffset(), "minutes") : i,
    end: n(o) ? r(o, -o.getTimezoneOffset(), "minutes") : o
  });
}

function l(e) {
  if (!e) return e;
  var i = e.start,
      o = e.end;
  return new t({
    start: n(i) ? r(i, i.getTimezoneOffset(), "minutes") : i,
    end: n(o) ? r(o, o.getTimezoneOffset(), "minutes") : o
  });
}

export { u as getTimeExtentFromLayers, l as toLocalTimeExtent, a as toUTCTimeExtent };